export default "__VITE_ASSET__Y1svDVN2__"